import { FocusEvent } from 'react';
import { useTranslation } from 'react-i18next';

export const useValidations = () => {
    const { t } = useTranslation();

    const trimOnBlur = (e: FocusEvent<HTMLInputElement>) => {
        e.target.value = e.target.value.trim();
    };

    const passwordRequired = {
        onBlur: trimOnBlur,
        required: t('Validation.Password.Required')
    };

    const emailValidation = {
        onBlur: trimOnBlur,
        required: t('Validation.Email.Required'),
        maxLength: { value: 245, message: t('Validation.Email.MaxLength') },
        pattern: { value: /^[\w!#$%&'*+/=?`{|}~^-]+(?:\.[\w!#$%&'*+/=?`{|}~^-]+)*@(?:[A-Z0-9-]+\.)+[A-Z]{2,24}$/i, message: t('Validation.Email.Invalid') }
    };

    const firstNameValidation = {
        onBlur: trimOnBlur,
        required: t('Validation.FirstName.Required'),
        maxLength: { value: 35, message: t('Validation.FirstName.MaxLength') }
    };

    const lastNameValidation = {
        onBlur: trimOnBlur,
        required: t('Validation.LastName.Required'),
        maxLength: { value: 35, message: t('Validation.LastName.MaxLength') }
    };

    const nicknameValidation = {
        onBlur: trimOnBlur,
        required: t('Validation.Nickname.Required'),
        minLength: { value: 3, message: t('Validation.Nickname.MinLength') },
        maxLength: { value: 70, message: t('Validation.Nickname.MaxLength') }
    };

    const companyNameValidation = {
        onBlur: trimOnBlur,
        maxLength: { value: 100, message: t('Validation.CompanyName.MaxLength') }
    };

    const passwordCodeValidation = {
        onBlur: trimOnBlur,
        required: t('Validation.ForgotPasswordCode.Required')
    };

    const termsOfAgreementValidation = {
        required: t('Validation.TermsOfAgreement.Required')
    };

    return {
        passwordRequired,
        emailValidation,
        firstNameValidation,
        lastNameValidation,
        nicknameValidation,
        companyNameValidation,
        passwordCodeValidation,
        termsOfAgreementValidation
    };
};
